import React, { useRef, useEffect, useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Modal } from "bootstrap";
import useOnceEffect from "../../Hooks/useOnceEffect";
import { VacantesCerradas } from "../../pages/Company/EstadoVacantes";
import CustomSwitch from "../../utils/Switch/Switch";

const Empleos = ({ id, edit }) => {
  const [listVacants, setlistVacants] = useState([]);
  const [sending, setSending] = useState(false);
  const [applicant, setapplicant] = useState("");
  const [vacanteAplicar, setVacanteAplicar] = useState("");
  const [closeVacantId, setcloseVacantId] = useState("");
  const [flag, setflag] = useState(false);
  const [ROLE, setRole] = useState("");
  const [showActiveVacants, setShowActiveVacants] = useState(true);

  const [data, setData] = useState("");

  const USER_BASE_URL = useRef("");

  const history = useHistory();
  let userId = localStorage.getItem("userId");
  let name = localStorage.getItem("username");

  useEffect(() => {
    axios.get("company-vacant/list-vacants/" + id).then((result) => {
      setlistVacants(result.data);
      getData(result.data[0].companyDTOResponse.companyVacantId);
    });

    {
      localStorage.getItem("rol") === "applicant" &&
        axios.get("access/applicant/" + userId).then((result) => {
          setapplicant(result.data.applicantProfile);
        });
    }
  }, [flag]);

  const guardarVacante = async (id) => {
    let data = {
      aplicarVacanteId: 0,
      fechaAplicacion: new Date(),
      habilidades: "string",
      insignia: 0,
      test: "false",
      applicantProfileId: applicant.applicantProfileId,
      vacanteEmpresaId: id,
    };

    axios
      .post("/company-vacant/vacant-favorite/", data)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
        }
      })
      .catch((e) => {
        if (e?.response && e?.response?.status === 400) {
          toast.error(e.response.data.message, { duration: 5000 });
        } else {
          if (!e.status) {
            toast.error(
              "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
              { duration: 5000 }
            );
          }
        }
      });
  };

  const getData = (id) => {
    axios
      .get("/company-vacant/" + id)
      .then((result) => {
        setData(result.data);
      })
      .catch((e) => {
        if (e.response.status === 500) {
          history.push("/user/Empleos");
        }
      });
  };

  const aplicarVacante = (id) => {
    if (!data.aplico) {
      axios
        .post("/company-vacant/apply-vacant/", {
          aplicarVacanteId: 0,
          fechaAplicacion: new Date(),
          habilidades: "string",
          insignia: 0,
          test: "false",
          applicantProfileId: applicant.applicantProfileId,
          vacanteEmpresaId: id,
        })
        .then((result) => {
          getData(id);
        });

      sendMail(id);
    } else {
      axios
        .post("company-vacant/close-applicant-vacant/" + data.aplicarVacanteId)
        .then((result) => {
          toast.success("Aplicacion cancelada");
          getData(id);
        });
    }
  };

  async function sendMail(companyvacantID) {
    const res = await axios.post(
      "access/notification-vacant/" + companyvacantID
    );
  }
  const h = {
    textAlign: "center",
  };
  function SearchVacante(id) {
    const vacante = listVacants.find(
      (item) => item.companyDTOResponse.companyVacantId === id
    );
    setVacanteAplicar(vacante);
    aplicarVacante();
  }

  function CerrarVacante() {
    const mod = new Modal(document.getElementById("cerrar-vacante-modal"));
    axios.post("company-vacant/close/" + closeVacantId).then((result) => {
      if (result.status === 200) {
        toast.success(result.data.message, {
          duration: 4000,
        });
        mod.hide();
        setflag(flag ? false : true);
      }
    });
  }

  const EditarVacante = (id) => {
    history.push({
      pathname: USER_BASE_URL.current,
      state: {
        vacantId: id,
      },
    });
  };

  function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    document.body.removeChild(textArea);
  }

  function copyTextToClipboard(text) {
    text = window.location.href
      .toString()
      .replace("#", "")
      .replace("/user/PerfilEmpresa", text);
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(
      function () {
        toast.success("Enlace de la vacante fue copiado al portapapeles", {
          duration: 4000,
        });
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      }
    );
  }

  const btnEditar = {
    background: "#7821A0 0% 0% no-repeat padding-box",
    borderRadius: "32px",
    opacity: "1",
    textAlign: "center",
    letterSpacing: "0px",
    color: "#FFFFFF",
    width: "133px",
    height: "38px",
    verticalAlign: "middle",
    display: "table-cell",
    cursor: "pointer",
  };

  const btnCancelar = {
    background: "#F1F1F1 0% 0% no-repeat padding-box",
    borderRadius: "32px",
    opacity: 1,
    textAlign: "center",
    letterSpacing: "0px",
    color: "#7821A0",
    height: "38px",
    width: "173px",
  };

  useOnceEffect(() => {
    if (id != null) {
      baseUrl();
    }
  });

  function baseUrl() {
    const role = localStorage.getItem("rol");
    setRole(role);
    switch (role) {
      case "applicant":
        USER_BASE_URL.current = "Vacante/Publica";
        break;
      case "company":
        USER_BASE_URL.current = "Vacante/Publica";
        break;
      case "institute":
        USER_BASE_URL.current = "Vacante/Publica";
        break;

      default:
        break;
    }
  }

  return (
    <div className="vacancy__description bordered-box vacantes perfil-empresa usuario">
      <div className="bordered-box__header">
        <div className="bordered-box__header-title d-flex justify-content-between align-items-center">
          <h5>Empleos</h5>

          <CustomSwitch
            label="Vacantes activas"
            onchange={setShowActiveVacants}
          />
        </div>
      </div>
      <div className="recomendaciones">
        {showActiveVacants && (
          <Vacantes
            {...{
              listVacants,
              aplicarVacante,
              setcloseVacantId,
              EditarVacante,
              btnEditar,
              btnCancelar,
              edit,
              guardarVacante,
              applicant,
              copyTextToClipboard,
              data,
            }}
          />
        )}
        {!showActiveVacants && <ClosedVacants companyId={id} />}
      </div>

      <div
        id="kr-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={h}>
              <h3 htmlFor="cargo">
                Tu aplicación ha sido enviada exitosamente
              </h3>
            </div>
            {/* <div className="modal-footer">
              <button
                type="button"
                data-bs-dismiss="modal"
                //onClick={aplicarVacante}
                className="btn btn--small btn--purple"
                disabled={sending}
              >
                Agregar
              </button>
            </div>*/}
          </div>
        </div>
      </div>

      <div
        id="cerrar-vacante-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-sm" role="document">
          <div id="jobs" className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <div
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </div>
            </div>

            <div className="modal-body">
              <div className="form form--white">
                <div className="div__wrapper">
                  <div className="form__title text-center">
                    ¿Estas seguro que deseas cerrar la Vacante?
                  </div>
                  <div className="form__row">
                    <div className="col-sm-12 ">
                      <label htmlFor="names">
                        {" "}
                        Nota:Al cerrar la vacante,ya no podras recibir mas
                        pustulaciones de esta Vacante
                      </label>
                    </div>
                  </div>
                  <div
                    className="form__row mt-5"
                    id="buttons"
                    style={{ textAlign: "center" }}
                  >
                    <div
                      data-dismiss="modal"
                      className="btn btn-light"
                      style={{ borderRadius: "30px", padding: "15px" }}
                    >
                      {" "}
                      Cancelar
                    </div>
                    <div
                      className="btn btn-info"
                      style={{ padding: "14px" }}
                      onClick={() => CerrarVacante()}
                    >
                      Cerrar Vacante
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function Vacantes({
  listVacants = [],
  applicant = [],
  aplicarVacante,
  setcloseVacantId,
  EditarVacante,
  btnEditar,
  btnCancelar,
  edit,
  guardarVacante,
  copyTextToClipboard,
  data,
}) {
  return listVacants.map((item, index) => (
    <div key={index} className="box" style={{ maxHeight: "421px" }}>
      <div className="one-half" style={{ maxHeight: "421px" }}>
        <div className="head">
          <div className="company__wrapper">
            <div className="logo">
              <img
                src={item.companyDTOResponse.fotoPerfilEmpresa}
                style={{ maxHeight: "138px", maxWidth: "130px" }}
                alt=""
              ></img>
            </div>

            <div className="content">
              <div className="cargo">{item.companyDTOResponse.cargo}</div>
              <div className="lugar">{item.companyDTOResponse.name}</div>
              <div className="cuidad">{item.companyDTOResponse.ubicacion}</div>
            </div>

            {localStorage.getItem("rol") === "applicant" && (
              <div className="aplicar">
                {data.aplico ? (
                  <button
                    className="btn btn--gradient"
                    onClick={() =>
                      aplicarVacante(item.companyDTOResponse.companyVacantId)
                    }
                  >
                    Cancelar
                  </button>
                ) : (
                  <button
                    className="btn btn--gradient"
                    data-bs-toggle="modal"
                    data-bs-target="#kr-modal"
                    data-title="Experiencia"
                    onClick={() =>
                      aplicarVacante(item.companyDTOResponse.companyVacantId)
                    }
                  >
                    Aplicar
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="body mb-0 mt-0">
          <div className="left-side">
            <ul>
              <li>Publicado: {item.companyDTOResponse.fechaPublicacion}</li>
              <li>Tipo: {item.companyDTOResponse.tipoEmpleo}</li>
              <li>Experiencia: {item.companyDTOResponse.tipoEmpleo}</li>
            </ul>
          </div>
          <div className="right-side">
            <ul>
              <li>
                <i className="fa fa-eye" aria-hidden="true"></i>{" "}
                Visualizaciones: {item.companyDTOResponse.visualizaciones}
                {localStorage.getItem("rol") !== "applicant" ? (
                  ""
                ) : (
                  <a
                    onClick={() =>
                      copyTextToClipboard(
                        "/user/Vacante/" +
                          item.companyDTOResponse.companyVacantId
                      )
                    }
                  >
                    <i className="fa fa-share-alt" aria-hidden="true"></i>
                  </a>
                )}
              </li>
              <li>
                <i className="fa fa-folder-open" aria-hidden="true"></i>{" "}
                Aplicando: {item.companyDTOResponse.cantidadAplicantes}
                {localStorage.getItem("rol") !== "applicant" ? (
                  ""
                ) : (
                  <a>
                    {" "}
                    <a
                      onClick={() =>
                        guardarVacante(item.companyDTOResponse.companyVacantId)
                      }
                    >
                      <i className="fa fa-bookmark" aria-hidden="true"></i>
                    </a>
                  </a>
                )}
              </li>
            </ul>
          </div>
        </div>

        <div className="footer mb-0 mt-0">
          <div className="actitudes">
            <div className="left-content col-8">
              Aptitudes:{" "}
              {item.listSkillVacante
                ?.map(function (lstSkills) {
                  return lstSkills.habilidad;
                })
                .join(" - ")}
            </div>
            <div className="right-content col-4">
              <a style={{ float: "right" }} href="#/">
                Salario:{" "}
                {item.companyDTOResponse.tipoMoneda +
                  " " +
                  item.companyDTOResponse.salario}
              </a>
            </div>
          </div>
          {localStorage.getItem("rol") !== "applicant" ? (
            <div className="bottom-content">
              <ul>
                {edit ? (
                  <li>
                    <a
                      href="#/"
                      style={btnCancelar}
                      data-bs-toggle="modal"
                      data-bs-target="#cerrar-vacante-modal"
                      onClick={() =>
                        setcloseVacantId(
                          item.companyDTOResponse.companyVacantId
                        )
                      }
                    >
                      Cancelar
                    </a>
                  </li>
                ) : null}
                {edit ? (
                  <li
                    onClick={() =>
                      EditarVacante(item.companyDTOResponse.companyVacantId)
                    }
                  >
                    <a href="#/" style={btnEditar}>
                      Editar
                    </a>
                  </li>
                ) : null}
              </ul>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  ));
}

function ClosedVacants({ companyId }) {
  return (
    <VacantesCerradas
      companyId={companyId}
      render={(listVacants, CloseReason) =>
        listVacants.map((item, index) => (
          <div key={index} className="box" style={{ maxHeight: "421px" }}>
            <div className="one-half" style={{ maxHeight: "421px" }}>
              <div className="head">
                <div className="company__wrapper">
                  <div className="logo">
                    <img
                      src={item.companyDTOResponse.fotoPerfilEmpresa}
                      style={{ maxHeight: "138px", maxWidth: "130px" }}
                      alt=""
                    ></img>
                  </div>

                  <div className="content">
                    <div className="cargo">{item.companyDTOResponse.cargo}</div>
                    <div className="lugar">{item.companyDTOResponse.name}</div>
                    <div className="cuidad">
                      {item.companyDTOResponse.ubicacion}
                    </div>
                  </div>
                </div>
              </div>

              <div className="body mb-0 mt-0">
                <div className="left-side">
                  <ul>
                    <li>
                      Publicado: {item.companyDTOResponse.fechaPublicacion}
                    </li>
                    <li>Tipo: {item.companyDTOResponse.tipoEmpleo}</li>
                    <li>Experiencia: {item.companyDTOResponse.tipoEmpleo}</li>
                  </ul>
                </div>
                <div className="right-side">
                  <ul>
                    <li>
                      <i className="fa fa-eye" aria-hidden="true"></i> Estado:
                      Cerrada
                    </li>
                  </ul>

                  {item.companyDTOResponse.closereason && (
                    <div>
                      Motivo de cierre:
                      <ul style={{ height: "unset", boxShadow: "none" }}>
                        {CloseReason(item.companyDTOResponse)}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))
      }
    />
  );
}

export default Empleos;
